import { TemplatePortal } from '@angular/cdk/portal'
import { Injectable, TemplateRef, ViewContainerRef, inject } from '@angular/core'
import { PortalService } from '../portal'

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly portalService = inject(PortalService)

  private _isOpen = false

  close(): void {
    this.portalService.setContent(undefined, true)
    this._isOpen = false
  }

  open(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef): void {
    this.portalService.setContent(new TemplatePortal(templateRef, viewContainerRef), true)
    this._isOpen = true
  }

  get isOpen(): boolean {
    return this._isOpen
  }
}
